<div class="block-page" data-testid="auth-block">
    <div class="block-card">
        <div class="block-icon">
            <svg width="32" height="32" viewBox="0 0 14 14">
                <use href="assets/icons/icons-sprite.svg#lock"></use>
            </svg>
        </div>

        <h3 class="block-title">Access Temporarily Blocked</h3>

        <p class="block-body">
            Too many verification attempts have been made on your account. For your security, access
            has been paused. Please wait a few minutes before trying again.
        </p>

        <ntv-button size="xl" variant="accent" (click)="backToLogin()">Back to Sign In</ntv-button>
    </div>
</div>
